module.exports = __webpack_public_path__ + "videos/hero-mobile_cn.0275460.mp4";